import { UpdateSubscriptionPreviewRequest, UpdateSubscriptionRequest } from '../../../typings/api';
import { get, put, remove } from '../api';

export const FETCH_SUBSCRIPTION = 'FETCH_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const FETCH_SUBSCRIPTION_PREVIEW = 'FETCH_SUBSCRIPTION_PREVIEW';
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';

const subscriptionActions = {
  fetchSubscription: () => ({
    type: FETCH_SUBSCRIPTION,
    async payload() {
      return get('/api/organization/subscription');
    },
  }),
  updateSubscription: (updateRequest: UpdateSubscriptionRequest) => ({
    type: UPDATE_SUBSCRIPTION,
    meta: {
      ...updateRequest,
    },
    async payload() {
      return put('/api/organization/subscription', updateRequest);
    },
  }),
  fetchSubscriptionPreview: (previewParams: UpdateSubscriptionPreviewRequest) => ({
    type: FETCH_SUBSCRIPTION_PREVIEW,
    async payload() {
      return get('/api/organization/subscription/preview', false, previewParams);
    },
  }),
  cancelSubscription: () => ({
    type: CANCEL_SUBSCRIPTION,
    async payload() {
      return remove('/api/organization/subscription');
    },
  }),
};

export default subscriptionActions;
